export class LoginTextDataIT {
  static readonly SEOlLabel = {
    appTitle: 'Accesso Utente - Piattaforma di Remediation PDF | PREP',
  };
  static readonly htmlLabel = {
    appName: 'Piattaforma di Remediation PDF',
    ssoUserLogin: 'ACCESSO UTENTE APPLE',
    userLogin: 'ACCESSO UTENTE',
    appWelcome: 'Benvenuto nella Console PREP',
    requiredFieldMessage:
      'I campi contrassegnati con un asterisco (*) sono obbligatori.',
    email: 'E-Mail',
    emailError: 'Per favore, inserisci il tuo indirizzo email',
    emailInvalidError: 'Per favore, inserisci un indirizzo email valido',
    emailFormatHint: 'nome@esempio.com',
    password: 'Password',
    passwordError: 'Abbiamo bisogno di una password per accedere',
    passwordMinLengthError: 'La password deve essere di almeno 6 caratteri',
    passwordHint: "Clicca sull'icona dell'occhio per alternare la visibilità",
    rememberMe: 'Ricordami per i futuri accessi',
    forgotPassword: 'Hai dimenticato la password?',
    signIn: 'ACCEDI',
    signInLoading: 'Accesso in corso...',
    ssoSignIn: 'ACCESSO SINGOLO',
    ssosignInLoading: 'Accesso singolo in corso...',
    privacyPolicy: 'Informativa sulla Privacy',
    privacyPolicyHint:
      'Prima di cliccare su Accedi, puoi consultare la nostra azienda',
    spinnerText: 'Caricamento in corso, attendere prego...',
    poweredBy: 'Offerto da',
    skipToMain: 'Salta al contenuto principale',
  };
  static readonly snackbarLabels = {
    errorInternetConnection: 'Errore: Controlla la connessione a Internet!',
    errorLogin400: 'Errore: Accesso fallito. E-Mail o Password errati!',
    errorLogin401:
      "Errore: Accesso fallito. L'utente può accedere solo su un dispositivo.",
    SuccessSignIn: 'Accesso riuscito. Reindirizzamento al Dashboard.',
  };
  static readonly tooltipLabels = {
    buttonPasswordToggle: 'Mostra/Nascondi Password',
  };
  static readonly ariaLabels = {
    main: 'Contenuto della pagina di accesso',
    rememberMe: 'Ricordami per i futuri accessi',
    forgotPassword: 'Hai dimenticato la password?',
    signIn: 'Accedi',
    signInDisabled: 'Accedi (disabilitato o in caricamento)',
    signInBusy: 'Accedi (caricamento in corso)',
    showHidePassword: 'Mostra/Nascondi',
    passwordVisibilityToggle: {
      true: 'Nascondi password',
      false: 'Mostra password',
    },
    privacyNote: "Avviso sull'informativa sulla privacy",
    privacyPolicyLink:
      "Visualizza l'Informativa sulla Privacy della nostra azienda in una nuova scheda",
    loadingSpinner: 'Caricamento in corso, attendere prego',
    spinnerText: 'Caricamento in corso, attendere prego',
    loginPreferences: 'Preferenze di accesso',
    brandingSection: 'Sezione del marchio',
    languageSelector: 'Selettore della lingua',
  };
  static readonly altLabels = {
    prepLogo: 'Logo di PREP',
    continualEngineLogo: 'Logo di Continual Engine',
  };
}

export class ForgotPasswordTextDataIT {
  static readonly SEOlLabel = {
    appTitle: 'Password Dimenticata - Piattaforma di Remediation PDF | PREP',
  };
  static readonly htmlLabel = {
    appName: 'Piattaforma di Remediation PDF',
    appPagetitle: 'PASSWORD DIMENTICATA',
    requiredFieldMessage:
      'I campi contrassegnati con un asterisco (*) sono obbligatori.',
    email: 'E-Mail',
    emailError: 'Per favore, inserisci il tuo indirizzo email',
    emailInvalidError: 'Per favore, inserisci un indirizzo email valido',

    buttonSubmit: 'Invia',
    buttonGoBack: "TORNA ALL'ACCESSO",
    privacyPolicy: 'Informativa sulla Privacy',
    privacyPolicyHint:
      'Prima di cliccare su Accedi, puoi consultare la nostra azienda',
    spinnerText: 'Caricamento in corso, attendere prego...',
    poweredBy: 'Offerto da',
  };
  static readonly snackbarLabels = {
    errorInternetConnection: 'Errore: Controlla la connessione a Internet!',
    errorGeneric: 'Errore: Qualcosa è andato storto. Contatta il supporto!',
    SuccessSubmit:
      'Il link per reimpostare la password è stato inviato alla tua email. Controlla la tua email.',
  };
  static readonly ariaLabels = {
    skipLink: 'Salta al contenuto principale',
    privacyNote: 'Avviso sulla privacy',
    privacyPolicyLink:
      "Visualizza l'informativa sulla privacy della nostra azienda in una nuova scheda",
    spinner: 'Caricamento in corso, attendere prego',
  };
  static readonly altLabels = {
    prepLogo: 'Logo di PREP',
    continualEngineLogo: 'Logo di Continual Engine',
  };
}

export class ResetPasswordTextDataIT {
  static readonly SEOlLabel = {
    appTitle: 'Reimposta Password - Piattaforma di Remediation PDF | PREP',
  };
  static readonly htmlLabel = {
    appName: 'Piattaforma di Remediation PDF',
    resetPasswordHeading: 'REIMPOSTA PASSWORD',
    passwordLabel: 'Password',
    toggleHint: "Fai clic sull'occhio per mostrare o nascondere la password",
    resetPasswordButton: 'REIMPOSTA PASSWORD',
    privacyPolicy: 'Informativa sulla privacy',
    privacyPolicyHint: 'Prima di fare clic su Accedi, puoi consultare le informazioni sulla nostra azienda',
    spinnerText: 'Caricamento in corso, attendere...',
    poweredBy: 'Offerto da'
  };
  static readonly snackbarLabels = {
    messages: {
      success: 'Password cambiata con successo',
      error_404: 'URL già utilizzato o scaduto!',
    },
    action: 'OK GRAZIE',
  };
  static readonly tooltipLabels = {
    buttonPasswordToggle: 'Mostra/Nascondi Password',
  };
  static readonly ariaLabels = {
    main: 'Contenuto principale della pagina Reimposta Password',
    resetPasswordHeading: 'Reimposta Password',
    togglePasswordVisibility: 'Mostra o nascondi la password',
  };
  static readonly altLabels = {
    prepLogo: 'Logo PREP',
    continualEngineLogo: 'Logo Continual Engine',
  };
}
